import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Rider\CheckoutController::store
* @see app/Http/Controllers/Rider/CheckoutController.php:32
* @route '/profil/objednavka'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/profil/objednavka',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Rider\CheckoutController::store
* @see app/Http/Controllers/Rider/CheckoutController.php:32
* @route '/profil/objednavka'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\CheckoutController::store
* @see app/Http/Controllers/Rider/CheckoutController.php:32
* @route '/profil/objednavka'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\CheckoutController::store
* @see app/Http/Controllers/Rider/CheckoutController.php:32
* @route '/profil/objednavka'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\CheckoutController::store
* @see app/Http/Controllers/Rider/CheckoutController.php:32
* @route '/profil/objednavka'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const checkout = {
    store: Object.assign(store, store),
}

export default checkout